import { createRouter, createWebHashHistory } from 'vue-router'

 import Login from "@/views/Login";

import Template from "@/views/template/Template";
import Maxterm from "@/views/template/Maxterm";
// import detection from "@/views/detection/startDetect";
import Scene from "@/views/template/Scene";
import Record from "@/views/record/Record";
import Device from "@/views/device/Device";
import Role from "@/views/Role/Role";
import UserList from "@/views/User/UserList";
import AreaSetIndex from "@/views/Rrea/AreaSetIndex";
import Order from "@/views/order/Order";
import OrderGet from "@/views/order/OrderGet";
import LCMain from "@/components/LCMain";
import store from "@/store";
import Seal from "@/views/Seal/Seal";
import Statement from "@/views/State/Statement";
import Ask from "@/views/template/Ask";
import Instrument from '@/views/Tool/Instrument.vue';
import Toolbox from '@/views/Tool/Toolbox.vue';
import DeviceStatus from "@/views/DeviceStatus/DeviceStatus";
import Caps from "@/views/Cap/Caps.vue";

import TemOffWeb from "@/views/index/TemOffWeb";
import startDetect from "@/views/detection/startDetect";

import detectionInfo from "@/views/detection/detectionInfo";
import Observed from "@/views/detection/Observed";

import Alipay from "@/views/Alipay/Alipay.vue";
import OrderInfo from "@/views/Alipay/OrderInfo"
import dataShow from "@/views/index/dataShow"
const routes = [

   // { path: '/', name:'login' ,component:Login,  },
   //  { path: '/Template', name:'Template' ,component:Template},
   //  { path: '/Maxterm', name:'Maxterm', component: Maxterm },
   //  { path: '/Scene',name:'Scene', component: Scene },
   //  { path: '/Record',name:'Record', component: Record },
	// { path: '/Device',name:'device', component: Device },
   //  { path: '/Role', name:'Role' ,component:Role},
   //  { path: '/UserList', name:'UserList' ,component:UserList},
   //  { path: '/AreaSetIndex', name:'StructSetIndex' ,component:AreaSetIndex},
   //  { path: '/Order',name:'Order', component: Order },
    {
        path: '/',
        redirect: '/login'  // 默认跳转到登录页
    },
    {
        path: "/*",
        component:() => import('@/views/404.vue')
    },
    {
        path: '/login',
        name: 'login',
        component: Login
    },

    {
        path: '/TemOffWeb',
        name: 'TemOffWeb',
        component: TemOffWeb
    },

    // {path:'/instrument/:id', name:'Instrument',component:() => import(/* webpackChunkName: "about" */ '@/views/Tool/Instrument.vue')},
    // {path:'/tool',name:'Tool',component:() => import(/* webpackChunkName: "about" */ '@/views/Tool/Toolbox.vue')},

    {
        path:'/home',
        name:'首页',
        component:LCMain,
        redirect: '/dataShow',  // 默认子路由，解决 /home 空白问题
        children:[{
            path:'/UserList',
            name:'用户管理',
            component:UserList
        },
            {
                path:'/Template',
                name:'检测模板管理',
                component:Template
            },
            {
                path:'/Maxterm',
                name:'检测模板大项',
                component:Maxterm
            },
            {
                path:'/Scene',
                name:'检测模板细项',
                component:Scene
            },
            {
                path:'/startDetect',
                name:'检测报告初检',
                component:startDetect,

            },
            {
                path:'/infoDetection',
                // path:'/detection',
                name:'检测详情',
                component:detectionInfo
            },
            {
                path:'/Observed',
                name:'观测数据及测量结果记录',
                component:Observed
            },
            {
                path:'/record',
                name:'检测记录',
                component:Record,

            },
            {
                path:'/Device',
                name:'设备管理',
                component:Device
            },
            {
                path:'/Role',
                name:'权限管理',
                component:Role
            },
            {
                path:'/AreaSetIndex',
                name:'区域管理',
                component:AreaSetIndex
            },
            {
                path:'/Order',
                name:'任务创建',
                component:Order
            },
            {
                path:'/Order',
                name:'任务分配',
                component:Order
            },
            {
                path:'/OrderGet',
                name:'任务领取',
                component:OrderGet
            },
            {
                path:'/Seal',
                name:'电子印章管理',
                component:Seal
            },
            {
                path:'/State',
                name:'符合性声明',
                component:Statement
            },
            {
                path:'/Ask',
                name:'模板要求',
                component:Ask
            },
            {
                path:'/instrument',
                name:'仪器管理',
                component:Instrument
            },
            {
                path:'/tool',
                name:'工具箱管理',
                component:Toolbox
            },
            {
                path:'/Cap',
                name:'安全帽管理',
                component:Caps
            },
			{
                path:'/deviceStatus',
                name:'设备状态',
                component:DeviceStatus
            },
            {
                path:'/dataShow',
                name:'数据展示',
                component:dataShow
            },
            {
                path:'/pay',
                name:'支付',
                component:Alipay
            },
            {
                path:'/orderinfo',
                name:'支付明细',
                component:OrderInfo
            },

        ]
    },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes
});
router.beforeEach((to, from, next) => {
    if (to.path === '/login') {
        next();
        return;
    }

    // 更新 store 中的路径名称
    if (to.path === '/startDetect') {
        // startDetect 直接放行
    } else if (to.path === '/record') {
        if (localStorage.getItem("currentPathName") === "检测报告编制") {
            store.commit("setPath", "检测报告编制");
        }
        if (localStorage.getItem("currentPathName") === "检测报告审核") {
            store.commit("setPath", "检测报告审核");
        } else if (localStorage.getItem("currentPathName") === "检测报告批准") {
            store.commit("setPath", "检测报告批准");
        }
        if (localStorage.getItem("currentPathName") === "检测报告上传") {
            store.commit("setPath", "检测报告上传");
        } else if (localStorage.getItem("currentPathName") === "检测报告查询") {
            store.commit("setPath", "检测报告查询");
        }
    } else {
        if (to.path === '/Order') {
            if (localStorage.getItem("currentPathName") === "任务创建") {
                store.commit("setPath", "任务创建");
            } else if (localStorage.getItem("currentPathName") === "任务分配") {
                store.commit("setPath", "任务分配");
            }
        } else {
            localStorage.setItem("currentPathName", to.name);
            store.commit("setPath", to.name);
        }
    }

    next();
});
export default router
